export default __webpack_public_path__ + "static/media/mob_lk_1024.7f8d2082.webp";